<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="piv"></a> Copyright © 1996 by Carl H. Klaus<br/>
All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center">The Library of Congress has cataloged the print edition as follows:</p>
<p class="center">Klaus, Carl H.</p>
<p class="center">My vegetable love : a journal of a growing season / Carl H. Klaus.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-78587-1<br/>
1. Vegetable garden—Iowa—Iowa City—Anecdotes. 2. Gardeners—Iowa—Iowa City—Anecdotes. 3. Klaus, Carl H. I. Title.</p>
<p class="center"><span style="font-size: smaller">SB</span>320.7.18<span style="font-size: smaller">K</span>58 1996 96-17836<br/>
635'.092—dc20 <span style="font-size: smaller">CIP</span></p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-544-34352-8<br/>
v1.0614</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?42d40a97